import { commonRequest } from "../../services/ApiCall";
import { Helpers } from "../../services/Helpers";

export const BrandServices = {

    allBrands : async (data) =>{
        console.log('Received parameters data:',data);

        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortBy) {
            queryParams.append('sortBy', data.filters.sortBy);            
            queryParams.append('sortType', data.filters.sortType || 'desc');
        }

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-brand/list?${queryParams.toString()}`,{}, Helpers.token());
    },

    allBrandList : async (data) =>{
        console.log('Received parameters data:',data);
        if(data){
            const queryParams = new URLSearchParams();

            // Search parameters
            queryParams.append('searchKey', data.filters.searchKey || '');
            

            // Sorting parameters
            if (data.filters.sortBy) {
                queryParams.append('sortBy', data.filters.sortBy);            
                queryParams.append('sortType', data.filters.sortType || 'desc');
            }

            // Additional multi-column filters
            if (data.filters.filterOptions) {
                data.filters.filterOptions.forEach((filter, index) => {
                    if (filter.fieldName && filter.value) {
                        queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                        queryParams.append(`filters[${index}][operator]`, filter.operator);
                        queryParams.append(`filters[${index}][value]`, filter.value);
                        
                        if (index !== 0) {
                            queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                        }
                        
                        if (filter.operator === 'between') {
                            queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                        }
                    }
                });
            }
            console.log("queryParams",queryParams.toString());
            return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-brand/list/all?${queryParams.toString()}`,{}, Helpers.token());
        }else{
            return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-brand/list/all`,{}, Helpers.token());

        }
        const queryParams = new URLSearchParams();

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortBy) {
            queryParams.append('sortBy', data.filters.sortBy);            
            queryParams.append('sortType', data.filters.sortType || 'desc');
        }

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-brand/list/all`,{}, Helpers.token());
    },

    addBrand : async (data) =>{
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/service-brand`,data, Helpers.token());
    },

    updateBrand : async (data,id) =>{
        return await commonRequest("PATCH",  `${Helpers.URL()}/api/v2/admin/service-brand/${id}`, data, Helpers.token());
    },
    // deleteService : async (id) =>{
    //     return await commonRequest("DELETE",  `${Helpers.URL()}/category/${id}`, {}, Helpers.token());
    // },

    fetchBrandData : async (id) =>{
        return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-brand/brand-details/${id}`,{}, Helpers.token());
    },
    changeBrandStatus : async (id) =>{
        return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-master/changeStatus/${id}`, {}, Helpers.token());
    },
    subCategoryList : async (data)=>{
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/service-category/getSubCategories/${data.categoryId}`,{}, Helpers.token());
    },
    categoryList : async (data)=>{
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/service-category/getCategories`,{}, Helpers.token());
    },
    serviceList: async (data)=>{
        // return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-master/getServicesBySubcategory/${data.subCategoryId}`,{}, Helpers.token());

        return await commonRequest("get",  `${Helpers.URL()}/api/admin/service-master/getServicesBySubcategory/${data.subCategoryId}`,{}, Helpers.token());
    },
}
